import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { getCurrentUser, isAuthenticated } from '../services/auth.service';

interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  forbiddenForRoles?: string[];
  redirectPathWhenForbidden?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  forbiddenForRoles,
  redirectPathWhenForbidden = '/inventario-finca',
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isAuthenticated()) {
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        );
      }
      const role = getCurrentUser()?.user?.role;
      if (forbiddenForRoles?.length && role && forbiddenForRoles.includes(role)) {
        return <Redirect to={{ pathname: redirectPathWhenForbidden }} />;
      }
      return <Component {...props} />;
    }}
  />
);

export default ProtectedRoute;

